// extracted by mini-css-extract-plugin
export var active = "_ko-2";
export var recordingDot = "_ko-1";
export var recordingIndicator = "_ko-0";